import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService } from '../../core/http/settings.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import * as _moment from 'moment';
import { ReportService } from '../../core/http/report.service';
const moment = _moment;

@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.scss'],
})
export class PatientComponent implements OnInit {
  @ViewChild('table', { static: false }) table: ElementRef;

  cacheKey = `this.emplyees`;
  isLoading = true;
  Errors = null;
  patient;
  mode = 'view';
  emplyees: any = [];
  filterdPatient: any = [];
  searchRef: any = [];
  data = null;
  refLoad: boolean = true;
  timer;
  drVisible: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  date;
  startdate;
  enddate;
  st;
  dt;
  searchLoad = false;
  private _searchText: string;
  private _regNo: string;
  private _searchEmail: string;

  get searchText(): string {
    return this._searchText;
    return this._searchEmail;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterdPatient = this.filterEmployees(value);
    this._searchEmail = value;
    this.filterdPatient = this.filterEmployeesEmail(value);
  }
  set searchRegNo(value: string) {
    this._regNo = value;
    this.filterdPatient = this.filterEmployees(value);
  }
  set searchEmail(value: string) {
    this._searchEmail = value;
    this.filterdPatient = this.filterEmployeesEmail(value);
  }

  filterEmployees(searchString: string) {
    return this.emplyees.filter(
      (employee) =>
        employee.first_name
          .toLowerCase()
          .indexOf(searchString.toLowerCase()) !== -1
    );
  }
  filterEmployeesEmail(searchString: string) {
    return this.emplyees.filter(
      (employee) =>
        employee.E_mail_address.toLowerCase().indexOf(
          searchString.toLowerCase()
        ) !== -1
    );
  }
  searchPatient(newValue) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.searchNewPatient(newValue);
    }, 1000);
  }
  searchPatientPhone(newValue) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.searchNewPatient(newValue);
    }, 1000);
  }
  searchPatientRegNo(newValue) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.searchNewPatient(newValue);
    }, 1000);
  }
  searchPatientEmail(newValue) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.searchNewPatient(newValue);
    }, 1000);
  }

  serachAll() {
    this.searchLoad = true;

    var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.setting
      .getPatientsBySearch1(
        this.searchText,
        this.startdate,
        this.enddate,
        this._regNo
      )

      .subscribe(
        (resSuccess) => {
          this.emplyees = resSuccess;
          localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
          this.searchLoad = false;
          console.log(resSuccess);
        },
        (resErr) => {
          this.searchLoad = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
    localStorage.setItem('startdate', this.startdate);
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    localStorage.setItem('enddate', this.enddate);
    console.log(this.enddate);
  }

  searchNewPatient(newValue) {
    
    var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.setting.getPatientsBySearch(newValue).subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  constructor(
    public router: Router,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public reportService: ReportService
  ) {}

  getPatients() {
    
    var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.setting.getPatient().subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
        this.filterdPatient = this.emplyees;
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }
  ngOnInit(): void {
    var cacheValue = localStorage.getItem(this.cacheKey);
    this.emplyees = cacheValue ? JSON.parse(cacheValue) : [];
    this.isLoading = true;
    this.setting.getPatient().subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        localStorage.setItem(this.cacheKey, JSON.stringify(this.emplyees));
        this.filterdPatient = this.emplyees;
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  edit(patient) {
    this.mode = 'edit';
    console.log(patient);
    this.patient = patient;
  }
  back() {
    this.patient = {};
    this.mode = 'view';
  }
  exportAll(): void {
    this.reportService.exportData('patient');
  }
  exportCurrent(): void {
    /* table id is passed over here */
    let element = document.getElementById('table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
